 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","MessagesPage~profileFeed~profileGroupsView~profileMatchmaking~profileMatchmakingBuyerProductDetails~~899338ba":"MessagesPage~profileFeed~profileGroupsView~profileMatchmaking~profileMatchmakingBuyerProductDetails~~899338ba","MessagesPage~profileFriends~profileGroups~profileGroupsRequest":"MessagesPage~profileFriends~profileGroups~profileGroupsRequest","MessagesPage":"MessagesPage","profileFeed~profileGroupsView~strategyProjectPageView":"profileFeed~profileGroupsView~strategyProjectPageView","main~strategyProjectPageView":"main~strategyProjectPageView","strategyProjectPageView":"strategyProjectPageView","profileFeed":"profileFeed","profileGroupsView":"profileGroupsView","profileMatchmakingBuyerProductDetails":"profileMatchmakingBuyerProductDetails","profileMatchmaking~profileMatchmakingBuyerSubscriptions":"profileMatchmaking~profileMatchmakingBuyerSubscriptions","profileMatchmakingBuyerSubscriptions":"profileMatchmakingBuyerSubscriptions","profileMatchmaking~profileMatchmakingSellerProductDetails~profileMatchmakingSellerProducts~projectDetails":"profileMatchmaking~profileMatchmakingSellerProductDetails~profileMatchmakingSellerProducts~projectDetails","profileMatchmakingSellerProductDetails~profileMatchmakingSellerProducts":"profileMatchmakingSellerProductDetails~profileMatchmakingSellerProducts","profileMatchmakingSellerProductDetails":"profileMatchmakingSellerProductDetails","profileMatchmakingSellerProducts":"profileMatchmakingSellerProducts","profileMatchmaking~projectDetails":"profileMatchmaking~projectDetails","profileMatchmaking":"profileMatchmaking","projectDetails":"projectDetails","profileFriends":"profileFriends","profileGroups":"profileGroups","profileGroupsRequest":"profileGroupsRequest","MyStrategyProjects~profileGroupStrategyProjects":"MyStrategyProjects~profileGroupStrategyProjects","MyStrategyProjects":"MyStrategyProjects","profileGroupStrategyProjects":"profileGroupStrategyProjects","PrivateGroupsPage":"PrivateGroupsPage","StrategyProjects":"StrategyProjects","confirmForgotPassword":"confirmForgotPassword","confirmRegister":"confirmRegister","forgotPassword":"forgotPassword","login":"login","main":"main","profileGroupMembers":"profileGroupMembers","profileMatchmakingSellerSubscriptions":"profileMatchmakingSellerSubscriptions","profileSetting":"profileSetting","register":"register","strategyProjectsEditor":"strategyProjectsEditor"}[chunkId]||chunkId) + "." + {"404":"78908819","MessagesPage~profileFeed~profileGroupsView~profileMatchmaking~profileMatchmakingBuyerProductDetails~~899338ba":"45f74715","MessagesPage~profileFriends~profileGroups~profileGroupsRequest":"225edbe9","MessagesPage":"1dd39bb9","profileFeed~profileGroupsView~strategyProjectPageView":"3404807d","main~strategyProjectPageView":"ae744e6c","strategyProjectPageView":"7ccc65b6","profileFeed":"942714f3","profileGroupsView":"91b079a9","profileMatchmakingBuyerProductDetails":"583c28f0","profileMatchmaking~profileMatchmakingBuyerSubscriptions":"1d4824c0","profileMatchmakingBuyerSubscriptions":"0a8041ee","profileMatchmaking~profileMatchmakingSellerProductDetails~profileMatchmakingSellerProducts~projectDetails":"40b3e5a0","profileMatchmakingSellerProductDetails~profileMatchmakingSellerProducts":"86df329f","profileMatchmakingSellerProductDetails":"75b5218b","profileMatchmakingSellerProducts":"ce7479d8","profileMatchmaking~projectDetails":"420ac2b9","profileMatchmaking":"de7ec480","projectDetails":"0b1167bd","profileFriends":"97bfe960","profileGroups":"8a95e325","profileGroupsRequest":"7931c80a","MyStrategyProjects~profileGroupStrategyProjects":"2d807af4","MyStrategyProjects":"20e5a0ff","profileGroupStrategyProjects":"d31107b8","PrivateGroupsPage":"79968036","StrategyProjects":"cf859199","confirmForgotPassword":"c77a643a","confirmRegister":"d3fac061","forgotPassword":"7913c26d","login":"7b44c8d5","main":"742eb929","profileGroupMembers":"86dde795","profileMatchmakingSellerSubscriptions":"0e700e16","profileSetting":"3e572e86","register":"2d567df4","strategyProjectsEditor":"fff71603"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"MessagesPage":1,"profileFeed~profileGroupsView~strategyProjectPageView":1,"main~strategyProjectPageView":1,"strategyProjectPageView":1,"profileMatchmakingBuyerProductDetails":1,"profileMatchmaking~profileMatchmakingBuyerSubscriptions":1,"profileMatchmakingBuyerSubscriptions":1,"profileMatchmaking~profileMatchmakingSellerProductDetails~profileMatchmakingSellerProducts~projectDetails":1,"profileMatchmakingSellerProductDetails~profileMatchmakingSellerProducts":1,"profileMatchmakingSellerProductDetails":1,"profileMatchmakingSellerProducts":1,"profileMatchmaking~projectDetails":1,"profileMatchmaking":1,"projectDetails":1,"profileFriends":1,"profileGroups":1,"profileGroupsRequest":1,"MyStrategyProjects~profileGroupStrategyProjects":1,"PrivateGroupsPage":1,"StrategyProjects":1,"main":1,"profileGroupMembers":1,"profileMatchmakingSellerSubscriptions":1,"profileSetting":1,"register":1,"strategyProjectsEditor":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","MessagesPage~profileFeed~profileGroupsView~profileMatchmaking~profileMatchmakingBuyerProductDetails~~899338ba":"MessagesPage~profileFeed~profileGroupsView~profileMatchmaking~profileMatchmakingBuyerProductDetails~~899338ba","MessagesPage~profileFriends~profileGroups~profileGroupsRequest":"MessagesPage~profileFriends~profileGroups~profileGroupsRequest","MessagesPage":"MessagesPage","profileFeed~profileGroupsView~strategyProjectPageView":"profileFeed~profileGroupsView~strategyProjectPageView","main~strategyProjectPageView":"main~strategyProjectPageView","strategyProjectPageView":"strategyProjectPageView","profileFeed":"profileFeed","profileGroupsView":"profileGroupsView","profileMatchmakingBuyerProductDetails":"profileMatchmakingBuyerProductDetails","profileMatchmaking~profileMatchmakingBuyerSubscriptions":"profileMatchmaking~profileMatchmakingBuyerSubscriptions","profileMatchmakingBuyerSubscriptions":"profileMatchmakingBuyerSubscriptions","profileMatchmaking~profileMatchmakingSellerProductDetails~profileMatchmakingSellerProducts~projectDetails":"profileMatchmaking~profileMatchmakingSellerProductDetails~profileMatchmakingSellerProducts~projectDetails","profileMatchmakingSellerProductDetails~profileMatchmakingSellerProducts":"profileMatchmakingSellerProductDetails~profileMatchmakingSellerProducts","profileMatchmakingSellerProductDetails":"profileMatchmakingSellerProductDetails","profileMatchmakingSellerProducts":"profileMatchmakingSellerProducts","profileMatchmaking~projectDetails":"profileMatchmaking~projectDetails","profileMatchmaking":"profileMatchmaking","projectDetails":"projectDetails","profileFriends":"profileFriends","profileGroups":"profileGroups","profileGroupsRequest":"profileGroupsRequest","MyStrategyProjects~profileGroupStrategyProjects":"MyStrategyProjects~profileGroupStrategyProjects","MyStrategyProjects":"MyStrategyProjects","profileGroupStrategyProjects":"profileGroupStrategyProjects","PrivateGroupsPage":"PrivateGroupsPage","StrategyProjects":"StrategyProjects","confirmForgotPassword":"confirmForgotPassword","confirmRegister":"confirmRegister","forgotPassword":"forgotPassword","login":"login","main":"main","profileGroupMembers":"profileGroupMembers","profileMatchmakingSellerSubscriptions":"profileMatchmakingSellerSubscriptions","profileSetting":"profileSetting","register":"register","strategyProjectsEditor":"strategyProjectsEditor"}[chunkId]||chunkId) + "." + {"404":"31d6cfe0","MessagesPage~profileFeed~profileGroupsView~profileMatchmaking~profileMatchmakingBuyerProductDetails~~899338ba":"31d6cfe0","MessagesPage~profileFriends~profileGroups~profileGroupsRequest":"31d6cfe0","MessagesPage":"a5e53472","profileFeed~profileGroupsView~strategyProjectPageView":"429b60f2","main~strategyProjectPageView":"4116596f","strategyProjectPageView":"14a14b0b","profileFeed":"31d6cfe0","profileGroupsView":"31d6cfe0","profileMatchmakingBuyerProductDetails":"cc458918","profileMatchmaking~profileMatchmakingBuyerSubscriptions":"b7a0acc3","profileMatchmakingBuyerSubscriptions":"3264e2f1","profileMatchmaking~profileMatchmakingSellerProductDetails~profileMatchmakingSellerProducts~projectDetails":"4655ee77","profileMatchmakingSellerProductDetails~profileMatchmakingSellerProducts":"add398c1","profileMatchmakingSellerProductDetails":"17abc760","profileMatchmakingSellerProducts":"27488211","profileMatchmaking~projectDetails":"18de40ce","profileMatchmaking":"e8bef536","projectDetails":"b696e25a","profileFriends":"1f15f27e","profileGroups":"3a1cffaa","profileGroupsRequest":"28417b20","MyStrategyProjects~profileGroupStrategyProjects":"a9b2ed63","MyStrategyProjects":"31d6cfe0","profileGroupStrategyProjects":"31d6cfe0","PrivateGroupsPage":"7c953817","StrategyProjects":"90aa1a80","confirmForgotPassword":"31d6cfe0","confirmRegister":"31d6cfe0","forgotPassword":"31d6cfe0","login":"31d6cfe0","main":"9df1d043","profileGroupMembers":"3550a831","profileMatchmakingSellerSubscriptions":"92a75763","profileSetting":"aef87ddb","register":"b85d5f94","strategyProjectsEditor":"349db114"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
